export function getEnvironment() {
  const hostname = window.location.hostname;

  if (hostname === 'pvolve.com' || hostname === 'www.pvolve.com') {
    return {
      apiBase: 'https://api.pvolve.com',
      appBase: 'https://app.pvolve.com',
      isStaging: false,
      isProduction: true,
    }
  }

  // isStaging covers all non-production environments (local, preview, QA).
  // In the future this may be split into isDevelopment and isStaging.
  return {
    apiBase: 'https://api.qa.pvolve.com',
    appBase: 'https://app.qa.pvolve.com',
    isStaging: true,
    isProduction: false,
  }
}
